// extracted by mini-css-extract-plugin
module.exports = {"mobile_width":"991px"};